import cookiejs from "cookiejs";

export default class CookieDent {

  constructor(name) {
    this.name = name;
    this.expires = 365;
    this.path = '/';
    this.values = this.loadValues();
  }

  setValue(key, value) {
    for (var i in this.values) {
      if (this.values[i][0] === key) {
        if (value) {
          this.values[i][1] = value;
        } else {
          this.values.splice(i, 1);
        }
        return this.save();
      }
    }
    this.values.push([key, value]);
    return this.save();
  }

  getValue(key) {
    for (var i in this.values) {
      if (this.values[i][0] === key) {
        return this.values[i][1];
      }
    }
    return null;
  }

  loadValues() {
    let cookie_values = cookiejs.get(this.name);

    if (cookie_values) {
      let values = cookie_values.split(":")
        .map(function (part) {
          return (part || "").split("$");
        }).filter(function (item) {
          return item.length === 2;
        });

      return values;
    }
    return [];
  }

  save() {
    let value = this.values
      .map(function (item) {
        return item.join("$")
      })
      .join(":");

    if (value.length === 0) {
      return this.delete();
    }

    cookiejs.set(
      this.name,
      value,
      {
        expires: this.expires,
        path: this.path
      }
    );
    return this;
  }

  delete() {
    cookiejs.remove(this.name, { path: this.path });
    return this;
  }
}
